import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { bindActionCreators } from 'redux';
import { Form, Formik } from 'formik';
import CustomLoader from '../common/CustomLoader';
import { drapcodeIcon } from '../../common/custom/icon-library';
import AceEditor from 'react-ace';
import 'ace-builds/src-noconflict/mode-xml';
import 'ace-builds/src-noconflict/theme-monokai';
import { validateXmlContent } from '../../common/utils/validate';
import { AppSettingsNav } from '../common/ui/AppSettingsNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';

export class SitemapXml extends Component {
  static propTypes = {
    appSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId, version } = match.params;
    actions.loadProjectDetailAppSetting({ projectId, version });
  }

  handleSitemapXmlSubmit = (values) => {
    const { projectId, version } = this.props.match.params;
    this.props.actions.addProjectSitemapXml({
      projectId,
      version,
      data: values,
    });
  };

  render() {
    const { appSetting } = this.props || {};
    const { projectDetail, addProjectSitemapXmlPending } = appSetting;
    let sitemapXml = '';
    if (!projectDetail) {
      return <div>Loading...</div>;
    }
    const { content } = projectDetail;
    sitemapXml = content && content.sitemapXml ? content.sitemapXml : '';

    return (
      <CommonPageComponent>
        <AppSettingsNav activeTab={'sitemapXml'} projectDetail={projectDetail} />
        <ParentContentCard title="Create Sitemap.xml" bgColor="drapcode-violet" icon="sitemapXml">
          <Formik
            initialValues={{ sitemapXml }}
            validate={(values) => {
              const errors = {};
              const xmlError = validateXmlContent(values.sitemapXml);
              if (xmlError) {
                errors.sitemapXml = xmlError;
              }
              return errors;
            }}
            onSubmit={(values, { setSubmitting }) => {
              this.handleSitemapXmlSubmit(values);
              setSubmitting(false);
            }}
          >
            {({
              isSubmitting,
              setFieldValue,
              setFieldTouched,
              resetForm,
              values,
              errors,
              touched,
            }) => (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div className="form-group">
                      <AceEditor
                        mode="xml"
                        theme="github"
                        name="sitemapXml"
                        value={values.sitemapXml}
                        onChange={(value) => setFieldValue('sitemapXml', value)}
                        onBlur={() => setFieldTouched('sitemapXml', true)}
                        fontSize={16}
                        showPrintMargin={false}
                        width="100%"
                        height="75vh"
                        placeholder={`Insert your sitemap.xml content here..\nEg. <?xml version="1.0" encoding="UTF-8"?>\n<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">\n  <url>\n    <loc>http://www.example.com/</loc>\n    <lastmod>2023-01-01</lastmod>\n    <changefreq>monthly</changefreq>\n    <priority>0.8</priority>\n  </url>\n</urlset>`}
                      />
                      {errors.sitemapXml && touched.sitemapXml && (
                        <div className="text-danger">{errors.sitemapXml}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-12 col-lg-12 text-right d-flex justify-content-between">
                    <div>
                      <button
                        type="button"
                        className="btn btn-outline btn-md"
                        onClick={() => this.props.toggle('appConstant')}
                      >
                        <i className="wb webconnect-times"></i> Cancel
                      </button>
                    </div>
                    <div>
                      <button
                        type="reset"
                        className="btn btn-default btn-md"
                        onClick={() => {
                          resetForm({ values: { sitemapXml: '' } });
                          setFieldValue('sitemapXml', '');
                        }}
                      >
                        <span>
                          <i className={`wb ${drapcodeIcon('eraser')}`}></i>&nbsp;Clear
                        </span>
                      </button>
                      &nbsp;
                      {!(content && content.sitemapXml) ? (
                        <button
                          type="submit"
                          className="btn btn-theme-submit btn-md"
                          disabled={isSubmitting || addProjectSitemapXmlPending}
                          title="Save Sitemap.xml"
                        >
                          <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Save
                          <CustomLoader loading={addProjectSitemapXmlPending} />
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-theme-submit btn-md"
                          disabled={isSubmitting || addProjectSitemapXmlPending}
                          title="Update Sitemap.xml"
                        >
                          <i className={`wb ${drapcodeIcon('update')}`}></i>&nbsp;Update
                          <CustomLoader loading={addProjectSitemapXmlPending} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    appSetting: state.appSetting,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SitemapXml);
